/**
 * This component is used to trick webpack into not importing the next components
 */

const MockComponent = () => {
  return <></>;
};

export default MockComponent;
